import { Action, ActionReducer, createReducer, on } from '@ngrx/store';

import { DiagStackDtcActions } from './diag-stack-dtc.actions';
import { DiagStackDtcState } from './diag-stack-dtc.state';

export const initDiagStackDtcState: DiagStackDtcState = {
  activeDtcResponse: null,
  activeDtcLoading: false,
  activeDtcError: null,
};

export const diagStackDtcReducer: ActionReducer<DiagStackDtcState, Action> = createReducer(
  initDiagStackDtcState,
  on(
    DiagStackDtcActions.getActiveDtc.attempt,
    (state): DiagStackDtcState => ({
      ...state,
      activeDtcResponse: null,
      activeDtcLoading: true,
      activeDtcError: null,
    })
  ),
  on(
    DiagStackDtcActions.getActiveDtc.error,
    (state, { activeDtcError }): DiagStackDtcState => ({
      ...state,
      activeDtcResponse: null,
      activeDtcLoading: false,
      activeDtcError,
    })
  ),
  on(
    DiagStackDtcActions.getActiveDtc.success,
    (state, { activeDtcResponse }): DiagStackDtcState => ({
      ...state,
      activeDtcResponse,
      activeDtcLoading: false,
      activeDtcError: null,
    })
  )
);
